export default __webpack_public_path__ + "static/media/cloth.7bf5da36.png";